<template>
	<page gradient-background>
		<detail-base>
			<template #base>
				<div class="customer flex-center">
					<div class="customer-count flex-column flex-center">
						<b>{{baseInfo.product_count}}</b>
						<p>产品数</p>
					</div>
					<div class="flex-grow">
						<p class="customer-name">{{baseInfo.customer_name}}</p>
						<div class="customer-tag flex-wrap">
							<c-state dict="afterSaleOrderStateDic" tag :value="baseInfo.status"></c-state>
							<c-state dict="serviceTypeDic" tag :value="baseInfo.service_type"></c-state>
							<c-state dict="orderUrgencyDic" tag :angle="![5, 10].includes(baseInfo.status)" :value="baseInfo.urgency_level" @click="urgencyHandle"></c-state>
							<c-state v-if="baseInfo.is_delayed == 1" tag color="red">
								逾期<span v-if="baseInfo.delayed_days > 0">{{baseInfo.delayed_days}}天</span>
							</c-state>
						</div>
					</div>
				</div>
			</template>

			<template #info>
				<c-field label="客户电话"><a v-if="baseInfo.customer_contact_phone" :href="`tel:${baseInfo.customer_contact_phone}`">{{baseInfo.customer_contact_phone}} [{{baseInfo.customer_contact}}]<i class="tf" style="margin-left: .5em; color: #00A1E9;">&#xe679;</i></a></c-field>
				<c-field label="客户地址"><a @click="mapHandle">{{baseInfo.customer_address}}<i class="tf" style="margin-left: .5em; color: #00A1E9;">&#xe6d7;</i></a></c-field>
				<c-field label="上门时间">{{baseInfo.dispatch_start_time}}</c-field>
				<c-field label="工单执行人">
					<template v-if="baseInfo.charge_user_realname">{{baseInfo.charge_user_realname}}【负责人】</template>
					<template v-if="baseInfo.group_user_realname">、{{baseInfo.group_user_realname.replaceAll(',', '、')}}</template>
				</c-field>
			</template>

			<template v-if="baseInfo.user_type == 1" #bottom>
				<div v-if="signinActive" class="signin flex-column flex-center">
					<ul class="signin-flow flex">
						<li v-for="(item, i) in flowList" :key="i" class="flex-center flex-grow" :class="{'z-finish': item.state <= baseInfo.execute_status, 'z-active': item.state == baseInfo.execute_status + 1 && i != 3}">
							<i v-if="item.state <= baseInfo.execute_status" class="tf">&#xe65e;</i>
							<span>{{item.name}}</span>
						</li>
					</ul>

					<div v-if="baseInfo.execute_status == 2" class="signin-result flex-center">
						<div class="flex-center">
							<i v-if="baseInfo.clock_in_time" class="tf">&#xe65e;</i>
							<b>上班</b>
							<span v-if="baseInfo.clock_in_time">{{baseInfo.clock_in_time}}已打卡</span>
							<span v-else>未打卡</span>
						</div>
						<div class="flex-center">
							<i v-if="baseInfo.clock_out_time" class="tf">&#xe65e;</i>
							<b>下班</b>
							<span v-if="baseInfo.clock_out_time">{{baseInfo.clock_out_time}}已打卡</span>
							<span v-else>未打卡</span>
						</div>
					</div>

					<div class="flex">
						<div class="signin-button flex-column flex-center" :class="{'z-err': localInfo.error, 'z-dis': !localInfo.address}" @click="signinHandle()">
							<h5 v-if="localInfo.error && localInfo.address">异常</h5>
							<h5>{{signinTypeName}}打卡</h5>
							<p>{{sysDate ? new Date(sysDate).format('MM月dd日') : '-'}}</p>
							<span>{{sysDate ? new Date(sysDate).format('hh:mm:ss') : '-'}}</span>
						</div>
						
						<div v-if="[0, 1, 2, 3].includes(baseInfo.execute_status) && signinMemberOptions.length" class="signin-button flex-column flex-center z-batch" :class="{'z-err': localInfo.error, 'z-dis': !localInfo.address}" @click="signinBatchHandle()">
							<h5>多人</h5>
							<h5>{{signinTypeName}}打卡</h5>
							<p>{{sysDate ? new Date(sysDate).format('MM月dd日') : '-'}}</p>
							<span>{{sysDate ? new Date(sysDate).format('hh:mm:ss') : '-'}}</span>
						</div>
					</div>

					<div class="signin-address flex-center">
						<p v-if="!localInfo.error && !localInfo.address" class="ellipsis">获取定位中</p>
						<template v-else-if="localInfo.error == 1">
							<i class="tf">&#xed7b;</i>
							<span>您当前不在签到范围内</span>
							<c-link @click="getLocation(true)">{{localInfo.update ? '获取定位中' : '刷新定位'}}</c-link>
						</template>
						<template v-else-if="localInfo.error == 2">
							<i class="tf">&#xed7b;</i>
							<span>定位获取失败</span>
							<c-link @click="getLocation(true)">{{localInfo.update ? '获取定位中' : '重新获取'}}</c-link>
						</template>
						<p v-else class="ellipsis">您当前位置：{{localInfo.address}}</p>
					</div>
				</div>

				<div v-else-if="baseInfo.status != 0" class="progress flex-center-cross">
					<p class="progress-label">当前安装进度：</p>
					<c-progress :rate="[baseInfo.completion_progress || 0, 1]" color="#00ACA9" style="width: 3.7rem"></c-progress>
				</div>
			</template>
		</detail-base>

		<detail-content :tabs="tabList">
			<template #base>
				<template v-if="productList.length">
					<c-title>售后服务明细 ({{productList.length}})</c-title>
					<div>
						<goods-card
							v-for="(item, i) in productList"
							:key="i"
							:index="i + 1"
							:title="item.spec_model || '-'"
							:info="[
								`长：${item.length || '-'}mm`,
								`宽：${item.width || '-'}mm`,
								`件数：${item.pieces || '-'}`,
								`环接方式：${item.connection_method_name || '-'}`,
								`数量：${item.quantity || '-'}`
							]"
							:remark="item.item_remark"
						></goods-card>
					</div>
				</template>

				<c-title>其它信息</c-title>
				<c-detail>
					<c-detail-item label="工单编号">{{baseInfo.order_number}}</c-detail-item>
					<c-detail-item label="客户名称">{{baseInfo.customer_name}}</c-detail-item>
					<c-detail-item label="售后申请单">
						<c-link v-if="auth('m_app_aftersale_apply')" @click="mp.navigateWeb('/aftersales/apply/detail', {id: baseInfo.apply_id})">{{baseInfo.apply_order_code}}</c-link>
						<span v-else>{{baseInfo.apply_order_code}}</span>
					</c-detail-item>
                    <c-detail-item label="意见处理单">{{baseInfo.complaint_no}}</c-detail-item>
                    <c-detail-item v-if="baseInfo.complaint_no && baseInfo.need_revisit" label="是否需要再次上门">
                        <c-state dict="needRevisitDic" :value="baseInfo.need_revisit"></c-state>
                    </c-detail-item>
					<c-detail-item label="服务类型">
						<c-state dict="serviceTypeDic" :value="baseInfo.service_type"></c-state>
					</c-detail-item>
					<c-detail-item label="售后类别">
						<c-state dict="afterSaleTypeDic" :value="baseInfo.aftersale_type"></c-state>
					</c-detail-item>
					<c-detail-item v-if="auth('b_aftersale_apply_view')" label="预估收费金额">￥{{baseInfo.estimated_fee}}</c-detail-item>
					<c-detail-item v-if="auth('b_aftersale_order_edit') || auth('b_aftersale_order_cost_detail')" label="预估总成本">￥{{baseInfo.estimated_cost_total}}</c-detail-item>
					<c-detail-item label="售后网点">{{baseInfo.after_sale_outlet_name}}</c-detail-item>
					<c-detail-item label="公里数">{{baseInfo.customer_distance}}km
						<span v-if="baseInfo.customer_duration > 0">（驾车预计耗时：{{baseInfo.customer_duration}}小时）</span>
					</c-detail-item>
					<c-detail-item label="预约时间">{{baseInfo.appointment_start_time}} ~ {{baseInfo.appointment_end_time}}</c-detail-item>
					<c-detail-item v-if="baseInfo.user_type != 1" label="预计服务时长">{{baseInfo.estimated_service_days}}天</c-detail-item>
					<c-detail-item label="是否使用机台">
						<c-state dict="useMachineDic" :value="baseInfo.use_machine"></c-state>
					</c-detail-item>
					<c-detail-item label="出行方式">
						<c-state dict="travelModeDic" :value="baseInfo.travel_mode"></c-state>
					</c-detail-item>
					<c-detail-item label="现场图">
						<c-file-list :value="baseInfo.scene_images" size="mini"></c-file-list>
					</c-detail-item>
					<c-detail-item label="需求描述">{{baseInfo.demand_description}}</c-detail-item>
					<c-detail-item label="必备技能">{{baseInfo.require_skills}}</c-detail-item>
                    <c-detail-item label="星级要求"><c-state dict="starLevelDic" :value="baseInfo.require_star_level"></c-state></c-detail-item>
                    <c-detail-item label="业务员姓名">{{baseInfo.salesman_name}}</c-detail-item>
                    <c-detail-item label="业务员电话"><a v-if="baseInfo.salesman_phone" :href="`tel:${baseInfo.salesman_phone}`">{{baseInfo.salesman_phone}}<i class="tf" style="margin-left: .5em; color: #00A1E9;">&#xe679;</i></a></c-detail-item>
					<c-detail-item label="创建人">{{baseInfo.create_user_realname}}</c-detail-item>
					<c-detail-item label="创建时间">{{baseInfo.create_date}}</c-detail-item>
				</c-detail>
			</template>

			<template #record>
				<c-scroll scroll-x>
					<c-tab-list :tabs="logTabList" type="card" @change="logTabHandle"></c-tab-list>
				</c-scroll>
				<c-scroll-list ref="logList" :refresh="false">
					<template #default="{data, index}">
						<log-item
							:key="index"
							:date="data.create_date.replace(/:\d{2}$/, '')"
							:person="data.create_user_realname"
							:action="data.remark"
						>
							<template v-if="data.is_anomaly == 2" #tag>
								<c-state tag hollow color="#FFAE00" style="border-radius: .08rem; padding: 0 .08rem;">异常打卡</c-state>
							</template>
							<template v-if="data.data_list.length" #remark>
								<c-field v-for="(item, i) in data.data_list" :key="i" :label="item.label">{{item.content}}</c-field>
							</template>
							<template v-if="data.img_list" #image>
								<c-file v-for="(item, i) in data.img_list" :key="i" :src="item" media></c-file>
							</template>
						</log-item>
					</template>
				</c-scroll-list>
			</template>

			<template #member>
				<member-list>
					<member-item
						v-for="(item, i) in memberList"
						:key="i"
						:icon="item.head_photo"
						:name="item.user_realname"
						:tag="item.is_charge == 2 ? '负责人' : ''"
						:post="item.position_name"
						:tel="item.phone"
					></member-item>
				</member-list>
			</template>

			<template #order>
				<c-empty v-if="!docList.length"></c-empty>
				<view-doc-card v-for="(item, i) in docList" :key="i" :type="item.work_type" :data="item"></view-doc-card>
			</template>
		</detail-content>

		<detail-handle>
			<template v-if="baseInfo.status == 0||baseInfo.status == 1">
				<!-- <c-button size="detail" color="red">删除</c-button> -->
				<c-button v-if="auth('b_app_aftersale_order_edit')" size="detail" @click="mp.navigateWeb('/aftersales/work/edit', {id: baseInfo.id})">编辑</c-button>
			</template>

			<template v-else-if="baseInfo.status == 6">
				<template v-if="baseInfo.charge_user_id == userInfo.id">
					<c-button size="detail" color="main" @click="dateHandle">确认预约时间</c-button>
					<c-button v-if="!baseInfo.group_user_realname" size="detail" color="red" @click="rejectHandle">拒单</c-button>
				</template>
				<c-button v-if="auth('b_app_aftersale_order_edit')" size="detail" @click="mp.navigateWeb('/aftersales/work/edit', {id: baseInfo.id})">编辑</c-button>
			</template>

			<template v-else-if="baseInfo.status == 2">
				<c-button v-if="auth('b_app_aftersale_order_edit')" size="detail" @click="mp.navigateWeb('/aftersales/work/edit', {id: baseInfo.id})">编辑</c-button>
			</template>

			<template v-else-if="baseInfo.status == 3 && baseInfo.execute_status == 2">
				<c-button v-if="baseInfo.is_confirm_service_days != 1" size="detail" color="main" @click="startupHandle">确认完工日期</c-button>
				<template v-else>
					<c-button size="detail" color="main" @click="outputHandle(2)">确认完工</c-button>
					<c-button size="detail" @click="outputHandle(1)">每日报工</c-button>
				</template>
			</template>

			<template v-else-if="showAcceptButton">
				<c-button size="detail" color="main" @click="checkHandle">客户验收单</c-button>
			</template>

            <c-button v-if="auth('b_app_aftersale_order_complaint_confirm') && baseInfo.status == 5 && baseInfo.complaint_status==1" size="detail" color="main" @click="complaintConfirmHandle">处理单确认</c-button>


            <template v-if="moreMenu.length" #more>
				<c-menu ref="menu" :menu="moreMenu" @handle="moreButtonHandle"></c-menu>
			</template>
		</detail-handle>

		<c-dialog ref="urgency" title="紧急程度" height="4">
			<c-form ref="urgencyForm">
				<c-form-item label="工单紧急程度">
					<c-input type="hidden" name="id"></c-input>
					<c-radio-group name="urgency_level" :options="orderUrgencyDic"></c-radio-group>
				</c-form-item>
			</c-form>
		</c-dialog>

		<c-dialog ref="reject" title="拒单原因" height="6rem" button-name="确认拒单">
			<c-form ref="rejectForm">
				<c-form-item label="原因说明" required>
					<reason-option v-for="(item, i) in rejectReasonOptions" :key="i" :name="item" :selected="rejectReason == item" @click="rejectReason = item"></reason-option>
					<reason-option name="其它原因" :selected="rejectReason == 'other'" @click="rejectReason = 'other'">
						<c-input v-show="rejectReason == 'other'" name="refuse_reasons" placeholder="原因请写这里..."></c-input>
					</reason-option>
				</c-form-item>
			</c-form>
		</c-dialog>

		<c-dialog ref="date" title="修改预约时间" height="6rem" button-name="确认修改">
			<c-form ref="dateForm">
				<c-form-item label="客户预约时间" required>
					<c-datetime type="date" name="appointment_start_time"></c-datetime>
				</c-form-item>
				<c-form-item label="备注说明">
					<c-input name="remark"></c-input>
				</c-form-item>
			</c-form>
		</c-dialog>

		<c-dialog ref="start" title="确认计划完工日期" height="8rem" button-name="确认提交">
			<c-form ref="startForm">
				<c-form-item label="计划完工日期" required>
					<c-datetime type="date" name="confirm_end_date"></c-datetime>
				</c-form-item>
				<c-form-item label="补充现场信息">
					<c-input type="textarea" name="remark"></c-input>
				</c-form-item>
                <c-form-item label="现场图" v-if="isStartComplaintOrder" :required="isStartComplaintOrder">
                    <c-tips>提示：意见处理售后单需上传现场图片，请拍照上传以便后续分析核实</c-tips>
					<c-upload-file name="scene_images" media multiple="9" style="margin-top: .2rem" @click="uploadFile"></c-upload-file>
				</c-form-item>
				<c-form-item label="其他待确认人员" v-if="startMemberOptions.length">
					<member-list >
						<member-item
							v-for="(item, i) in startMemberOptions"
							:key="i"
							:icon="item.head_photo"
							:name="item.user_realname"
							:tag="item.is_charge == 2 ? '负责人' : ''"
							:post="item.position_name"
							:current="startMember.includes(item.user_id)"
							@click="startMember.includes(item.user_id) ? startMember.splice(startMember.indexOf(item.user_id), 1) : startMember.push(item.user_id)"
						></member-item>
					</member-list>
				</c-form-item>
			</c-form>
		</c-dialog>

		<c-dialog ref="signinBatch" title="多人一起打卡" height="5" button-name="确认打卡">
			<template v-if="signinMemberOptions.length">
				<c-tips>温馨提示：选择与您一起打卡的人员</c-tips>
				<member-list style="margin: 0 .4rem;">
					<member-item
						v-for="(item, i) in signinMemberOptions"
						:key="i"
						:icon="item.head_photo"
						:name="item.user_realname"
						:tag="item.is_charge == 2 ? '负责人' : ''"
						:post="item.position_name"
						:current="signinMember.includes(item.user_id)"
						:disabled="item.status != baseInfo.execute_status"
						@click="signinMember.includes(item.user_id) ? signinMember.splice(signinMember.indexOf(item.user_id), 1) : signinMember.push(item.user_id)"
					></member-item>
				</member-list>
			</template>
			<c-empty v-else message="暂无可一起打卡的成员"></c-empty>
		</c-dialog>

		<c-dialog ref="unusual" title="异常打卡" height="60vh" button-name="确认并打卡">
			<c-tips v-if="localInfo.address">当前位置：{{localInfo.address}}</c-tips>
			<c-form ref="unusualForm">
				<c-form-item label="原因说明" required>
					<reason-option v-for="(item, i) in signinReasonOptions" :key="i" :name="item" :selected="signinReason == item" @click="signinReason = item"></reason-option>
					<reason-option name="其它原因" :selected="signinReason == 'other'" @click="signinReason = 'other'">
						<c-input v-show="signinReason == 'other'" name="remark" placeholder="原因请写这里..."></c-input>
					</reason-option>
				</c-form-item>
				<c-form-item label="上传凭证" :required="[2, 3, 4].includes(signinType)">
					<c-upload-file name="voucher_images" media type="image" multiple="9" @click="takePhoto"></c-upload-file>
				</c-form-item>
			</c-form>
		</c-dialog>

		<c-dialog ref="signinSuccess" :title="false" :button="false" position="center" :close-button="false" @close="signinSuccess.abort()">
			<div class="signin-success flex-column flex-center">
				<h1 class="flex-center">
					<i class="tf">&#xe65e;</i>
					<span>{{signinSuccess.name}}打卡成功</span>
				</h1>
				<p class="flex-grow">打卡时间：{{signinSuccess.time}}</p>
				<div class="signin-success-button flex-center">
					<c-button v-if="signinSuccess.type != 1" class="flex-grow" color="main" @click="$refs.signinSuccess.close()">我知道了({{signinSuccess.timeout}}S)</c-button>
					<template v-else>
						<c-button @click="mp.reLaunch('/pages/home/index');">返回首页</c-button>
						<c-button class="flex-grow" color="main" @click="mp.redirectWeb('/aftersales/work')">返回列表</c-button>
					</template>
				</div>
			</div>
		</c-dialog>

		<c-dialog ref="output" height="60vh">
			<c-tips v-if="outputType == 1 && baseInfo.today_last_report_time">您今日已报过工 {{baseInfo.today_last_report_time}}</c-tips>
			<ul v-if="outputType == 2" class="output-tab flex">
				<li :class="{'z-crt': outputMode == 1}" @click="outputMode = 1">均分完工</li>
				<li :class="{'z-crt': outputMode == 2}" @click="outputMode = 2">各自完工</li>
			</ul>
			<c-form ref="outputForm">
				<p v-if="outputType == 1" class="output-time">当前报工时间：{{new Date(sysDate).format('yyyy-MM-dd hh:mm')}}</p>
				<c-form-item v-if="outputType == 2 && outputMode == 1" label="确认执行人员">
					<template v-if="outputType == 2" #handle>
						<c-link @click="$refs.outputMemberPicker.open();"><i class="tf">&#xe63d;</i> 添加人员</c-link>
					</template>
					<member-list style="padding: 0;">
						<member-item
							v-for="(item, i) in outputProduct.member"
							:key="i"
							:icon="item.head_photo"
							:name="item.user_name"
							:post="item.position_name"
							:remove="item.user_id != userInfo.id"
							@remove="outputProduct.member.splice(i, 1)"
						></member-item>
					</member-list>
				</c-form-item>
				<c-form-item label="确认完成事项">
					<template v-if="outputType == 2 && outputMode == 2" #handle>
						<c-link @click="$refs.outputMemberPicker.open();"><i class="tf">&#xe63d;</i> 代他人完工</c-link>
					</template>
					<detail-card v-for="(person, i) in outputItemList" :key="i" :tag="outputType == 2 && outputMode == 2 ? person.user_id == userInfo.id ? '我' : person.user_name : ''" :add-button="['添加产品', '从产品库中添加']" @add="addOutputMemberProduct(person, $event)" @delete="outputMember.splice(i, 1)">
						<template #list>
							<detail-card-list v-for="(item, j) in person.product_list" :key="j" delete-button @delete="person.product_list.splice(j, 1)">
								<detail-card-list-row label="完成产品">
									<c-select v-model="item.product_code" :options="productOptions" :disable-options="person.product_list.map(item => item.product_code)" placeholder="请选择产品">
										<template #option="{data, selected, disabled}">
											<select-option
												:name="data.name"
												:info="[
													`存货编码：${data.data.inventory_code || '-'}`,
													`环接方式：${data.data.connection_method_name || '-'}`,
													`长(mm)：${data.data.length || '-'} | 宽(mm)： ${data.data.width || '-'}`
												]"
												:selected="selected"
												:disabled="disabled"
											></select-option>
										</template>
									</c-select>
								</detail-card-list-row>
								<detail-card-list-row :columns="['1fr', '1fr']" :label="['件数(条数)', '工时']">
									<c-input v-model="item.pieces" type="number" decimal="2" :range="[0.01,99]" append-text="件"></c-input>
									<c-input v-model="item.work_hours" type="number" decimal="1" :range="[0.1,99]" append-text="小时"></c-input>
								</detail-card-list-row>
							</detail-card-list>
						</template>

						<template v-if="i" #button>
							<c-link color="red" icon="tf-trash" @click="outputMember.splice(i, 1)">删除</c-link>
						</template>
					</detail-card>
				</c-form-item>
				<c-form-item v-if="outputType == 2 && baseInfo.complaint_no" label="是否需要再次上门" required>
					<c-radio-group name="need_revisit" :options="needRevisitDic"></c-radio-group>
				</c-form-item>
				<c-form-item label="上传凭证">
					<c-upload-file name="voucher_images" media multiple="9" @click="uploadFile"></c-upload-file>
				</c-form-item>
				<c-form-item label="备注说明" :required="!hasOutputProduct">
					<c-input type="textarea" name="remark" :placeholder="hasOutputProduct ? '其它说明写这里 (非必填)' : '报工未填写明细时，备注说明必填'"></c-input>
				</c-form-item>

				<dl v-if="outputType == 2 && outputTotal.length" class="output-total">
					<dt class="flex-between-center" @click="$set(outputTotal, 'expand', !outputTotal.expand)">
						<b>已报工统计({{outputTotal.length}})</b>
						<ins class="flex-center"><i class="tf" :style="{'transform': `rotate(${outputTotal.expand ? 180 : 0}deg)`}">&#xe61c;</i></ins>
					</dt>
					<dd v-show="outputTotal.expand">
						<ul>
							<li v-for="(person, i) in outputTotal" :key="i">
								<h5>{{person.user_realname}}：</h5>
								<p v-for="(item, j) in person.product_list" :key="j" class="flex-between-center">
									<span>{{item.product_code}} {{item.spec_model || '-'}}</span>
									<span>完成{{item.pieces}}件</span>
									<span>消耗{{item.work_hours}}小时</span>
								</p>
							</li>
						</ul>
					</dd>
				</dl>
			</c-form>
		</c-dialog>

		<c-dialog ref="extraProduct" title="从产品库中添加" height="70vh">
			<c-form ref="extraProductForm">
				<c-form-item label="产品" required>
					<c-select ref="extraProductSelect" name="product_code" async @search="searchProduct"></c-select>
				</c-form-item>
				<c-form-item label="环接方式">
					<c-select ref="connectionSelect" name="connection_method" :options="connectionTypeOptions"></c-select>
				</c-form-item>
				<c-form-item label="长度" required>
					<c-input type="number" name="length" append-text="mm" :range="[0,Infinity]" @change="setQuantity"></c-input>
				</c-form-item>
				<c-form-item label="宽度" required>
					<c-input type="number" name="width" append-text="mm" :range="[0,Infinity]" @change="setQuantity"></c-input>
				</c-form-item>
				<c-form-item label="数量">
					<c-input type="number" name="quantity" append-text="平方米" decimal="6" :range="[0,Infinity]"></c-input>
				</c-form-item>
				<c-form-item label="件数(条数)" required>
					<c-input type="stepper" name="pieces" decimal="2" :range="[0.01,99]"></c-input>
				</c-form-item>
				<c-form-item label="工时" required>
					<c-input type="stepper" name="work_hours" :range="[1,99]"></c-input>
				</c-form-item>
			</c-form>
		</c-dialog>

		<c-dialog ref="check" title="客户验收单" height="6rem">
			<c-form ref="checkForm">
				<c-form-item label="上传客户验收单" required="">
					<c-upload-file name="voucher_images" media multiple="9" @click="uploadFile"></c-upload-file>
				</c-form-item>
				<c-form-item label="备注说明">
					<c-input type="textarea" name="remark" placeholder="其它说明写这里 (非必填)"></c-input>
				</c-form-item>
			</c-form>
		</c-dialog>

		<c-dialog ref="teamManage" title="管理团队成员" height="5" @resolve="teamManageHandle">
			<template>
				<c-tips>温馨提示：如需了解所有人员工作安排，可查看 <c-link @click="mp.navigateWeb('/aftersales/work/schedule')">工单日历</c-link></c-tips>
				<member-list style="margin: 0 .4rem;">
					<member-item
						v-for="(item, i) in teamMemberList"
						:key="i"
						:icon="item.head_photo"
						:name="item.user_realname"
						:tag="item.is_charge == 2 ? '负责人' : ''"
						:post="item.position_name"
						:remove="item.is_charge != 2 && item.status == 0"
						@remove="teamMemberList.splice(i, 1)"
					></member-item>
					<div class="add-member flex-center" @click="$refs.addMmemberPicker.open();"><i class="tf">&#xe727;</i></div>
				</member-list>
			</template>
		</c-dialog>

		<c-dialog ref="extendSchedule" title="延后完工日期" height="8rem" button-name="确认提交">
			<c-form ref="extendForm">
				<c-form-item label="计划完工日期" required>
					<c-datetime type="date" name="new_end_date"></c-datetime>
				</c-form-item>
				<c-form-item label="延后原因" required>
					<c-input type="textarea" name="extend_reason" placeholder="请填写延后原因"></c-input>
				</c-form-item>
				<c-form-item label="一起延后人员" v-if="extendMemberOptions.length">
					<member-list>
						<member-item
							v-for="(item, i) in extendMemberOptions"
							:key="i"
							:icon="item.head_photo"
							:name="item.user_realname"
							:tag="item.is_charge == 2 ? '负责人' : ''"
							:post="item.position_name"
							:current="extendSelected.includes(item.user_id)"
							@click="extendSelected.includes(item.user_id) ? extendSelected.splice(extendSelected.indexOf(item.user_id), 1) : extendSelected.push(item.user_id)"
						></member-item>
					</member-list>
				</c-form-item>
			</c-form>
		</c-dialog>

		<c-select-picker ref="outputMemberPicker" title="选择人员" :data="outputMemberOptions" multiple @resolve="outputMode == 1 ? addOutputProductMember($event) : addOutputMember($event)"></c-select-picker>
		<c-select-picker ref="addMmemberPicker" title="添加人员" multiple :search="{async: true}" :disabled="memberList.map(item => item.user_id)" @search="searchTeamMember" @resolve="setTeamMember"></c-select-picker>
	</page>
</template>

<script>
	import {mapState} from 'vuex';

	export default {
		props: {
			id: String
		},

		data() {
			return {
				sysDate: '',

				baseInfo: {},
				productList: [],
				memberList: [],
				docList: [],

				rejectReasonOptions: [],
				rejectReason: '',

				flowList: [{
					name: '出发',
					state: 1
				}, {
					name: '到达',
					state: 2
				}, {
					name: '服务中',
					state: 3
				}, {
					name: '完工',
					state: 3
				}, {
					name: '回网点',
					state: 4
				}],
				localInfo: {
					address: '',
					update: false,
					error: 0
				},
				signinMember: [],
				startMember: [],
				signinReasonOptions: [],
				signinReason: '',
				signinSuccess: {},

				outputType: 1,
				outputMode: 1,
				outputProduct: {
					member: [],
					list: []
				},
				outputMember: [],
				outputTotal: [],

				logTabList: [{
					name: '全部',
					value: ''
				}, {
					name: '反馈进度',
					value: 1
				}, {
					name: '打卡考勤',
					value: 2
				}, {
					name: '报工记录',
					value: 3
				}, {
					name: '完工记录',
					value: 4
				}],

				extendSelected: [],

				teamMemberList: [],

				extraProduct: [],
				connectionTypeOptions: [
					{value: 1, name: '热接 (平齿接/非斜齿)'},
					{value: 2, name: '热接（斜齿接）'},
					{value: 5, name: '扣接（钢扣）'},
					{value: 31, name: '开口打平齿'},
					{value: 32, name: '开口打斜齿'},
					{value: 11, name: '开口打齿'},
					{value: 9, name: '开口带'},
					{value: 10, name: '斜单长齿接'},
					{value: 6, name: '扣接（尼龙扣）'},
					{value: 7, name: '扣接（塑料扣）'},
					{value: 8, name: '冷接'},
					{value: 12, name: '齿接环带'},
					{value: 13, name: '接驳'},
					{value: 3, name: '热接（搭接）'},
					{value: 4, name: '热接（斜搭接）'},
					{value: 14, name: '环形'},
					{value: 15, name: '环带'},
					{value: 16, name: '无缝'},
					{value: 17, name: '细长齿接'},
					{value: 18, name: '牛鼻子接头'},
					{value: 19, name: '30 斜单齿接'},
					{value: 20, name: '单层齿接'},
					{value: 21, name: '反齿接'},
					{value: 22, name: '细短齿接'},
					{value: 23, name: '70 度斜齿接'},
					{value: 24, name: '对接'},
					{value: 25, name: '多层齿接'},
					{value: 26, name: '上齿下搭'},
					{value: 27, name: 'PPJ 穿销接头'},
					{value: 28, name: '大圆弧齿形'},
					{value: 29, name: '小圆弧齿形'},
					{value: 30, name: '菱形齿'},
				]
			}
		},

		computed: {
			...mapState(['sysTimeDiff', 'userInfo', 'orderUrgencyDic', 'needRevisitDic']),

			signinActive() {
				return [2, 3, 4, 5].includes(this.baseInfo.status) && this.baseInfo.user_type == 1 && this.baseInfo.execute_status != 4;
			},

			signinType() {
				if (this.baseInfo.execute_status == 2) {
					return this.baseInfo.sign_state == 0 ? 3 : 4;
				} else if (this.baseInfo.execute_status == 3) {
					return 5;
				} else {
					return this.baseInfo.execute_status + 1;
				}
			},

			signinTypeName() {
				return {
					1: '出发',
					2: '到达',
					3: '上班',
					4: '下班',
					5: '返回'
				}[this.signinType];
			},

			signinMemberOptions() {
				return this.memberList.filter(item => item.user_id != this.userInfo.id && item.status == this.baseInfo.execute_status);
			},

			startMemberOptions() {
				return this.memberList.filter(item => item.user_id != this.userInfo.id && item.status == this.baseInfo.execute_status && !item.confirm_end_date);
			},

			outputMemberOptions() {
				return this.memberList.map(item => {
					return {
						name: item.user_realname,
						value: item.user_id,
						data: item
					}
				}).filter(item => {
					return !this.outputMember.find(temp => temp.user_id == item.value);
				});
			},

			productOptions() {
				return this.productList.concat(this.extraProduct).map(item => {
					return {
						name: (item.spec_model || '-') + ' | ' + (item.length || '-') + ' | ' + (item.width || '-'),
						value: [item.product_code, item.connection_method, item.length, item.width, item.quantity].join('#key#'),
						data: item
					}
				});
			},

			outputItemList() {
				return this.outputType == 2 && this.outputMode == 1 ? [{product_list: this.outputProduct.list}] : this.outputMember;
			},

			hasOutputProduct() {
				return this.outputType == 2 && this.outputMode == 1
					? this.outputProduct.list.length > 0
					: this.outputMember.some(person => person.product_list.length > 0);
			},
			
			tabList() {
				return [{
					name: '基础资料',
					value: 'base'
				}, {
					name: '工单记录',
					value: 'record'
				}, {
					name: '团队成员' + (this.memberList.length ? `(${this.memberList.length})` : ''),
					value: 'member'
				}, {
					name: '关联单据' + (this.docList.length ? `(${this.docList.length})` : ''),
					value: 'order'
				}]
			},

			moreMenu() {
				return [{
					name: '管理团队成员',
					auth: [6, 2, 3].includes(this.baseInfo.status) && this.auth('b_app_aftersale_order_member'),
					event: () => {
						this.teamMemberList = this.memberList.map(item => item);
						this.$refs.teamManage.open();
					}
				}, {
					name: '申请费用报销',
					auth: [4, 5].includes(this.baseInfo.status) && this.baseInfo.is_reimbursement == 1 && this.baseInfo.user_type == 1,
					event: () => {
						this.mp.navigateWeb('/finance/reimb/edit', {source: this.baseInfo.id});
					}
				}, {
					name: '申请加班',
					auth: [3, 4, 5].includes(this.baseInfo.status) && this.baseInfo.user_type == 1,
					event: () => {
						this.mp.navigateWeb('/affairs/overtime/edit', {source: this.baseInfo.id});
					}
				}, {
					name: '申请资产领用',
					auth: [2, 3].includes(this.baseInfo.status) && this.baseInfo.user_type == 1,
					event: () => {
						this.mp.navigateWeb('/assets/receive/edit', {source: this.baseInfo.id});
					}
				}, {
					name: '申请资产归还',
					auth: [4, 5].includes(this.baseInfo.status) && this.baseInfo.user_type == 1,
					event: () => {
						this.mp.navigateWeb('/assets/return/edit');
					}
				}, {
					name: '修改售后位置',
					auth: this.baseInfo.status == 3 && this.auth('b_app_aftersale_order_edit'),
					event: () => {
						this.mp.navigateWeb('/aftersales/work/location/edit', {id: this.baseInfo.id});
					}
				}, {
					name: '申请外协招工',
					auth: [2, 3].includes(this.baseInfo.status) && this.baseInfo.user_type == 1,
					event: () => {
						this.mp.navigateWeb('/aftersales/outsource/edit', {source: this.baseInfo.id});
					}
				}, {
					name: '延后完工日期',
					auth: this.baseInfo.status == 3 && this.baseInfo.execute_status == 2 && this.baseInfo.is_confirm_service_days == 1,
					event: () => {
						this.extendHandle();
					}
				}].filter(item => item.auth !== false)
			},

			showAcceptButton() {
				let isMember = this.memberList.some(item => item.user_id == this.userInfo.id);
				if (!isMember) return false;
				if (this.baseInfo.status == 4) return true;
				return this.baseInfo.status == 3
					&& this.memberList.length > 0
					&& this.memberList.every(item => item.status >= 3);
			},

			isComplaintOrder() {
				return this.baseInfo.charge_user_id == this.userInfo.id && !!this.baseInfo.complaint_no;
			},

			isStartComplaintOrder() {
				return !!this.baseInfo.complaint_no
					&& (this.isComplaintOrder || this.startMember.includes(this.baseInfo.charge_user_id));
			},

			extendMemberOptions() {
				return this.memberList.filter(item => item.user_id != this.userInfo.id && item.confirm_end_date);
			},
		},

		mounted() {
			this.update();

			!function loop() {
				this.sysDate = new Date().getTime() - this.sysTimeDiff;

				setTimeout(() => {
					loop.call(this);
				}, 100);
			}.call(this);

			this._logLoad = () => {
				if (!this.$refs.logList._requestObj && this.$refs.logList.$refs.loading && this.$refs.logList.$refs.loading.getBoundingClientRect().top < this.$refs.logList.$el.getBoundingClientRect().bottom + this.$refs.logList.$el.getBoundingClientRect().height * 0.5) {
					this.$refs.logList.loadData();
				}
			};
			window.addEventListener('scroll', this._logLoad);
			
			this.$onShow(() => {
				this.update();
			});
		},

		beforeDestroy() {
			window.removeEventListener('scroll', this._logLoad);
		},

		methods: {
			update() {
				this.request({
					url: '/after/sale/order/detail',
					data: {
						id: this.id
					},
					success: ({detailInfo, productList, memberList, relatedList}) => {
						this.baseInfo = detailInfo;
						this.productList = productList;
						this.memberList = memberList;
						this.docList = relatedList;
						this.getLocation();
					}
				});
				this.$refs.logList.reload();
			},

			mapHandle() {
				this.mp.navigateTo('/pages/power', {
					power: 'openLocation',
					data: `${this.baseInfo.customer_address_longitude},${this.baseInfo.customer_address_latitude}`
				});
			},

			getLocation(update) {
				if (!this.signinActive || this.localInfo.update) return;
				
				this.WXReady(() => {
					wx.getLocation({
						type: 'gcj02',
						success: ({longitude, latitude}) => {
							this.request({
								url: '/location/analysis',
								data: {
									order_id: this.id,
									longitude,
									latitude
								},
								success: data => {
									this.localInfo = {
										longitude,
										latitude,
										address: data.complete_address,
										province_id: data.province_id,
										city_id: data.city_id,
										county_id: data.county_id,
										update: false,
										error: data.sign_in_valid == 0 ? 1 : 0
									}
									update && this.$message({
										message: '定位已刷新'
									});
								},
								fail: (code, data, message) => {
									this.$message({
										message
									})
									this.localInfo.update = false;
									this.localInfo.error = 2;
								}
							})
						},
						fail: res => {
							this.$message({
								message: res.errMsg
							})
							this.localInfo.update = false;
							this.localInfo.error = 2;
						},
						cancel: () => {
							this.localInfo.update = false;
							this.localInfo.error = 2;
						}
					});
				});
			},

			signinHandle(others) {
				if (!this.localInfo.address) return;

				new Promise(resolve => {
					if (this.localInfo.error) {
						this.$refs.unusualForm.clear();
						this.signinReason = '';
						this.request({
							url: '/system/options',
							data: {
								options_code: 'DIC_INFO',
								dic_code: [3, 4].includes(this.signinType)
									? 'WORK_SIGN_ANOMALY_REASON'
									: this.signinType == 2
										? 'ARRIVE_SIGN_ANOMALY_REASON'
										: 'DEPART_SIGN_ANOMALY_REASON'
							},
							success: data => {
								this.signinReasonOptions = data.map(item => item.name);
							}
						});
						this.$refs.unusual.open({
							resolve: (stop, next) => {
								stop();
								this.$refs.unusualForm.validate({
									breakWhenFail: true,
									rule: {
										reason: [{
											type: 'function',
											message: '请选择或填写异常原因',
											fun: (val, data) => {
												return this.signinReason && (this.signinReason != 'other' || data.remark.trim());
											}
										}],
										voucher_images: [{
											type: 'empty',
											message: '请上传凭证',
											skip: () => {
												return ![2, 3, 4].includes(this.signinType);
											}
										}]
									},
									success: data => {
										data.is_anomaly = 2;
										data.voucher_images = data.voucher_images.join(',');
										if (this.signinReason != 'other') {
											data.remark = this.signinReason;
										}
										next();
										resolve(data);
									}
								});
							}
						});
					} else {
						resolve();
					}
				}).then(data => {
					this.request({
						url: '/after/sale/order/sign/add',
						data: Object.assign({
							order_id: this.id,
							accompany_user_ids: others,
							is_anomaly: 1,
							sign_type: this.signinType,
							address_longitude: this.localInfo.longitude,
							address_latitude: this.localInfo.latitude,
							province_id: this.localInfo.province_id,
							city_id: this.localInfo.city_id,
							county_id: this.localInfo.county_id,
							address_detail: this.localInfo.address
						}, data),
						loading: true,
						success: () => {
							this.update();
							
							this.signinSuccess = {
								type: this.signinType,
								name: this.signinTypeName,
								time: new Date(this.sysDate).format('yyyy-MM-dd hh:mm'),
								timeout: 3,
								abort: () => {
									clearTimeout(this._signinSuccessTimer);
								}
							};
							this.$refs.signinSuccess.open();
							if (this.signinSuccess.type != 1) {
								!function loop() {
									this._signinSuccessTimer = setTimeout(() => {
										if (--this.signinSuccess.timeout > 0) {
											loop.call(this);
										} else {
											this.$refs.signinSuccess.close();
										}
									}, 1000);
								}.call(this);
							}
						}
					});
				});
			},

			signinBatchHandle() {
				if (!this.localInfo.address) return;

				this.signinMember = this.signinMemberOptions.map(item => item.user_id);
				this.$refs.signinBatch.open({
					resolve: (stop, next) => {
						let ids = this.signinMember;
						if (!ids.length) {
							stop();
							this.$message({
								message: '请选择随行人员'
							});
							return;
						}
						this.signinHandle(ids);
					}
				});
			},

			urgencyHandle() {
				if ([5, 10].includes(this.baseInfo.status)) return;
				this.$refs.urgencyForm.set({
					urgency_level: this.baseInfo.urgency_level
				});
				this.$refs.urgency.open({
					resolve: (stop, next) => {
						stop();
						this.$refs.urgencyForm.submit({
							url: '/after/sale/order/edit/urgency_level',
							dataFormatter: data => {
								data.id = this.id;
								return data;
							},
							success: () => {
								next();
								this.$message({
									message: '设置成功'
								});
								this.update();
							}
						})
					}
				});
			},

			logTabHandle(tab) {
				this.$refs.logList.load({
					url: '/after/sale/order/log/list',
					data: {
						order_id: this.id,
						log_type: tab.value
					},
					dataFormatter: data => {
						data.forEach(item => {
							if (!item.data_json) return;
							item.data_list = [];

							if (item.report_list) {
								item.report_list.forEach(person => {
									person.product_list.forEach(product => {
										item.data_list.push({
											content: `${person.user_name} | ${product.product_code} ${product.inventory_name || '-'} | 长：${product.length || '-'}mm 宽：${product.width || '-'}mm | | ${item.operation_type == 30 ? '完工总数' : '报工数'}：${product.pieces}件 | 工时：${product.work_hours}小时`
										});
									});
								});
							}

							if (item.operation_type == 2) {
								item.data_json.forEach(field => {
									item.data_list.push({
										content: `【${field.字段}】: 【${field.原值 || '空'}】 → 【${field.新值 || '空'}】`
									});
								});
							} else {
								item.data_json.forEach(field => {
									let key = Object.keys(field)[0];
									item.data_list.push({
										label: key,
										content: field[key]
									});
								});
							}
						});
						return data;
					}
				});
			},

			rejectHandle() {
				this.$refs.rejectForm.clear();
				this.rejectReason = '';
				this.request({
					url: '/system/options',
					data: {
						options_code: 'DIC_INFO',
						dic_code: 'REFUSE_REASON'
					},
					success: data => {
						this.rejectReasonOptions = data.map(item => item.name);
					}
				});
				this.$refs.reject.open({
					resolve: (stop, next) => {
						stop();
						this.$refs.rejectForm.submit({
							url: '/after/sale/order/refuse',
							breakWhenFail: true,
							rule: {
								reason: [{
									type: 'function',
									message: '请选择或填写拒单原因',
									fun: (val, data) => {
										return this.rejectReason && (this.rejectReason != 'other' || data.refuse_reasons.trim());
									}
								}]
							},
							dataFormatter: data => {
								data.order_id = this.id;
								if (this.rejectReason != 'other') {
									data.refuse_reasons = this.rejectReason;
								}
								return data;
							},
							success: () => {
								this.$message({
									message: '提交成功'
								});
								next();
								this.mp.navigateBack();
							}
						});
					}
				});
			},

			dateHandle() {
				this.$refs.dateForm.clear();
				this.$refs.dateForm.set({
					appointment_start_time: this.baseInfo.appointment_start_time
				});
				this.$refs.date.open({
					resolve: (stop, next) => {
						stop();
						this.$refs.dateForm.submit({
							url: '/after/sale/order/edit/appointment_time',
							breakWhenFail: true,
							rule: {
								appointment_start_time: '请选择预约时间'
							},
							dataFormatter: data => {
								data.order_id = this.id;
								return data;
							},
							success: () => {
								this.$message({
									message: '提交成功'
								});
								next();
								this.update();
							}
						});
					}
				});
			},

			startupHandle() {
				this.$refs.startForm.clear();
				this.startMember = this.startMemberOptions.map(item => item.user_id);
				this.$refs.start.open({
					resolve: (stop, next) => {
						stop();
						this.$refs.startForm.submit({
							url: '/after/sale/order/edit/member/service_days',
							breakWhenFail: true,
							rule: {
								confirm_end_date: '请填写计划完工日期',
                                scene_images: [{
                                    type: 'empty',
                                    message: '请上传现场图',
                                    skip: () => {
                                        return !this.isStartComplaintOrder;
                                    }
                                }]
							},
							dataFormatter: data => {
								data.order_id = this.id;
								data.member_user_ids = this.startMember;
								return data;
							},
							success: () => {
								this.$message({
									message: '提交成功'
								});
								next();
								this.update();
							}
						});
					}
				});
			},

			async outputHandle(type) {
				this.outputType = type;
				this.extraProduct = [];

				if (type == 2) {
					await this.request({
						url: '/after/sale/order/report/list',
						data: {
							order_id: this.id
						},
						loading: true,
						success: data => {
							this.outputTotal = data;
						}
					});
				}

				this.outputMember = [];
				this.$nextTick(() => {
					type == 2 && this.initOutputProduct();
					this.addOutputMember([{
						name: this.userInfo.user_realname,
						value: this.userInfo.id
					}]);
				});
				this.$refs.outputForm.clear();
				this.$refs.output.open({
					title: type == 2 ? '确认完工' : '每日报工',
					buttonName: type == 2 ? '确认完工' : '确认报工',
					resolve: (stop, next) => {
						stop();
						this.$refs.outputForm.validate({
							breakWhenFail: true,
							rule: {
								report_list: [{
									type: 'function',
									message: '请完善产品及数量信息',
									fun: (val, data) => {
										if (type == 2 && this.outputMode == 1) {
											return !this.outputProduct.list.find(item => !item.product_code || !item.pieces || !item.work_hours);
										} else {
											return !this.outputMember.find(person => {
												return !!person.product_list.find(item => !item.product_code || !item.pieces || !item.work_hours);
											});
										}
									}
								}],
                                remark: [{
                                    type: 'function',
                                    message: '报工明细和备注说明至少填写一项',
                                    fun: (val, data) => {
                                        let hasRemark = data.remark && data.remark.trim();
                                        return this.hasOutputProduct || hasRemark;
                                    }
                                }],
                                need_revisit: [{
                                    type: 'empty',
                                    message: '请选择是否需要再次上门',
                                    skip: () => {
                                        return !(type == 2 && this.baseInfo.complaint_no);
                                    }
                                }],
							},
							success: data => {
								data.voucher_images = data.voucher_images.join(',');
								this.request({
									url: '/after/sale/order/report',
									data: Object.assign({
										order_id: this.id,
										report_type: type,
										report_list: type == 2 && this.outputMode == 1
											? this.outputProduct.member.map(person => {
												return {
													user_id: person.user_id,
													user_name: person.user_name,
													product_list: this.outputProduct.list.map(item => {
														let data = item.product_code.split('#key#');
														return {
															product_code: data[0],
															connection_method: data[1],
															length: data[2],
															width: data[3],
															quantity: data[4],
															pieces: parseFloat((item.pieces / this.outputProduct.member.length).toFixed(2)),
															work_hours: item.work_hours
														}
													})
												}
											})
											: this.hasOutputProduct
												? this.outputMember.filter(person => person.product_list.length > 0).map(person => {
													return {
														user_id: person.user_id,
														user_name: person.user_name,
														product_list: person.product_list.map(item => {
															let data = item.product_code.split('#key#');
															return {
																product_code: data[0],
																connection_method: data[1],
																length: data[2],
																width: data[3],
																quantity: data[4],
																pieces: item.pieces,
																work_hours: item.work_hours
															}
														})
													}
												})
												: []
									}, data),
									loading: true,
									success: () => {
										this.$message({
											message: '提交成功'
										});
										next();
										this.update();
									}
								});
							}
						});
					}
				});
			},

			initOutputProduct() {
				let list = {};
				this.outputTotal.forEach(member => {
					member.product_list.forEach(product => {
						let key = [product.product_code, product.connection_method, product.length, product.width, product.quantity].join('#key#');
						if (!list[key]) {
							list[key] = {
								product_code: key,
								pieces: 0,
								work_hours: 0
							};
						}
						list[key].pieces += parseFloat(product.pieces) || 0;
						list[key].work_hours += parseFloat(product.work_hours) || 0;
					});
				});
				this.outputProduct.member = [];
				this.outputProduct.list = Object.keys(list).map(key => list[key]);
				this.addOutputProductMember([{
					name: this.userInfo.user_realname,
					value: this.userInfo.id,
					data: {
						head_photo: this.userInfo.head_photo,
						position_name: this.userInfo.position_name
					}
				}]);
				this.addOutputProductMember(this.outputMemberOptions.map(item => {
					return {
						name: item.data.user_realname,
						value: item.data.user_id,
						data: {
							head_photo: item.data.head_photo,
							position_name: item.data.position_name
						}
					}
				}));
			},

			addOutputProductMember(data) {
				data.forEach(item => {
					if (this.outputProduct.member.find(temp => temp.user_id == item.value)) return;
					this.outputProduct.member.push({
						user_id: item.value,
						user_name: item.name,
						head_photo: item.data.head_photo,
						position_name: item.data.position_name
					})
				})
			},

			addOutputMember(data) {
				data.forEach(item => {
					let total = this.outputType == 2 ? this.outputTotal.find(temp => temp.user_id == item.value) : null;
					let person = {
						user_id: item.value,
						user_name: item.name,
						product_list: total ? total.product_list.map(product => {
							let key = [product.product_code, product.connection_method, product.length, product.width, product.quantity].join('#key#');
							if (!this.productOptions.find(item => item.value == key)) {
								this.extraProduct.push(product);
							}
							return {
								product_code: key,
								pieces: product.pieces,
								work_hours: product.work_hours
							}
						}) : []
					}
					this.outputMember.push(person);
					if (!person.product_list.length && this.productList.length) {
						this.addOutputMemberProduct(person);
					}
				})
			},

			addOutputMemberProduct(person, type) {
				if (type == 1) {
					this.$refs.extraProductForm.clear();
					this.$refs.extraProduct.open({
						resolve: (stop, next) => {
							stop();
							this.$refs.extraProductForm.validate({
								rule: {
									product_code: '请选择产品',
									length: '请填写长度',
									width: '请填写宽度',
									pieces: '请填写件数',
									work_hours: '请填写工时'
								},
								success: data => {
									let connection = this.$refs.connectionSelect.getData();
									let product = this.$refs.extraProductSelect.getData().data;
									product = Object.assign({}, product, {
										connection_method_name: connection.name
									}, data);

									let key = [product.product_code, product.connection_method, product.length, product.width, product.quantity].join('#key#');
									if (!this.productOptions.find(item => item.value == key)) {
										this.extraProduct.push(product);
									}

									let temp = person.product_list.find(item => item.product_code == key);
									if (temp) {
										temp.pieces = parseFloat(temp.pieces) + parseFloat(product.pieces);
										temp.work_hours = parseFloat(temp.work_hours) + parseFloat(product.work_hours);
									} else {
										person.product_list.push({
											product_code: key,
											pieces: product.pieces,
											work_hours: product.work_hours
										});
									}
									
									next();
								}
							})
						}
					});
				} else {
					person.product_list.push({
						product_code: '',
						pieces: 1,
						work_hours: 1
					});
				}
			},

			searchProduct(keyword, resolve) {
				this.request({
					url: '/system/options',
					data: {
						options_code: 'PRODUCT',
						keyword
					},
					success: data => {
						resolve(data);
					}
				})
			},

			setQuantity() {
				let data = this.$refs.extraProductForm.get();
				this.$refs.extraProductForm.set({
					quantity: data.length && data.width ? parseFloat((data.length * data.width / 1000 / 1000).toFixed(6)) : ''
				});
			},

			checkHandle() {
				this.$refs.checkForm.clear();
				this.$refs.check.open({
					resolve: (stop, next) => {
						stop();
						this.$refs.checkForm.submit({
							url: '/after/sale/order/accept',
							breakWhenFail: true,
							rule: {
								voucher_images: '请上传凭证'
							},
							dataFormatter: data => {
								data.order_id = this.id;
								data.voucher_images = data.voucher_images.join(',');
								return data;
							},
                            loading: true,
							success: () => {
								this.$message({
									message: '提交成功'
								});
								next();
								this.update();
							}
						});
					}
				})
			},

            complaintConfirmHandle() {
                this.$confirm({
                    message: '是否确认意见处理单' + this.baseInfo.complaint_no + '？',
                    resolve: () => {
                        this.request({
                            url: '/after/sale/order/complaint_confirm',
                            data: {
                                order_id: this.id
                            },
                            loading: true,
                            success: () => {
                                this.$message({
                                    message: '确认成功'
                                });
                                this.update();
                            }
                        });
                    }
                });
            },

			searchTeamMember(keyword, resolve) {
				this.request({
					url: '/system/options',
					data: {
						options_code: 'SYSUSER',
						is_engineer: 1,
						keyword
					},
					success:data => {
						resolve(data);
					}
				})
			},

			setTeamMember(data) {
				this.teamMemberList = this.teamMemberList.concat(data.map(item => {
					item.data.user_id = item.data.id;
					item.data.status = 0;
					return item.data;
				}));
			},

			extendHandle() {
				this.extendSelected = [];
				this.$refs.extendForm.clear();
				this.$refs.extendSchedule.open({
					resolve: (stop, next) => {
						stop();
						this.$refs.extendForm.validate({
							breakWhenFail: true,
							rule: {
								new_end_date: '请选择新完工日期',
								extend_reason: '请填写延后原因'
							},
							success: data => {
								let memberUserIds = [this.userInfo.id].concat(this.extendSelected);
								this.request({
									url: '/after/sale/order/schedule/extend',
									data: {
										order_id: this.id,
										new_end_date: data.new_end_date,
										extend_reason: data.extend_reason.trim(),
										member_user_ids: memberUserIds
									},
									loading: true,
									success: () => {
										this.$message({message: '提交成功'});
										next();
										this.update();
									}
								});
							}
						});
					}
				});
			},

			async teamManageHandle(stop, next) {
				stop();
				if (this.baseInfo.status == 2 && this.baseInfo.schedule_start_time) {
					let {data, message} = await this.request({
						url: '/after/sale/order/dispatch/conflict',
						data: {
							order_id: this.id,
							member_user_ids: this.teamMemberList.map(item => item.user_id)
						},
						loading: true
					});
					
					if (data == 1 && await this.$confirm({
						title: '排期冲突',
						message,
						buttonName: '继续修改',
						cancelButtonName: '取消修改'
					}) == 'cancel') {
						return
					}
				}

				this.request({
					url: '/after/sale/order/edit_member',
					data: {
						order_id: this.id,
						member_list: this.teamMemberList.map(item => item.user_id)
					},
					loading: true,
					success: () => {
						next();
						this.$message({
							message: '操作成功'
						});
						this.update();
					}
				});
			}
		}
	}
</script>

<style lang="stylus" scoped>
	.customer {
		gap: .26rem;

		&-count {
			gap: .12rem;
			width: 1rem;
			height: 1rem;
			border-radius: .08rem;
			font-size: .22rem;
			color: #fff;
			background: var(--color-main);

			b {
				font-size: .36rem;
			}
		}

		&-name {
			font-size: .32rem;
			color: #28324B;
		}

		&-tag {
			gap: .12rem;
			margin-top: .2rem;
		}
	}

	.progress {
		height: .92rem;

		&-label {
			font-size: .26rem;
			color: #999;
		}
	}

	.signin {
		&-flow {
			gap: .04rem;
			width: 100%;
			margin: .1rem 0 .24rem;
			overflow: hidden;

			li {
				gap: .06rem;
				position: relative;
				height: .44rem;
				font-size: .26rem;
				color: #666;
				background: #F5F5F5;

				&.z-finish {
					color: #fff;
					background: #00ACA9;
				}

				&.z-active {
					color: #00A1E9;
				}
			}
		}

		&-result {
			gap: .18rem;
			margin-bottom: .28rem;

			div {
				gap: .08rem;
				height: .6rem;
				border-radius: .08rem;
				padding: 0 .2rem;
				font-size: .24rem;
				color: #666;
				background: #F5F5F5;

				.tf {
					font-size: .32rem;
					color: #00A1E9;
				}

				b {
					font-size: .28rem;
					color: #000;
				}
			}
		}

		&-button {
			width: 2.4rem;
			height: 2.4rem;
			border-radius: 50%;
			margin: 0 .26rem;
			color: #fff;
			background: #00A1E9;
			box-shadow: 0 .04rem .16rem 0 rgba(0,161,233,.3);

			&.z-batch {
				background: #20CEB7;
				box-shadow: 0 .04rem .16rem 0 rgba(0,161,233,.3);
			}

			&.z-err {
				background: #FFC000;
				box-shadow: 0 .04rem .16rem 0 rgba(255,192,0,.3);
			}

			&.z-dis {
				background: #bbb;
				box-shadow: none;
			}

			h5 {
				line-height: .46rem;
				font-size: .36rem;
			}

			p {
				margin: .18rem 0 .16rem; 
				font-size: .26rem;
			}

			span {
				font-size: .26rem;
				opacity: .6;
			}
		}

		&-batch {
			margin-top: .2rem;
		}

		&-address {
			gap: .12rem;
			width: 100%;
			height: .86rem;
			font-size: .26rem;
			color: #91A1B9;

			.tf {
				font-size: .3rem;
				color: #FFC000;
			}
		}

		&-success {
			box-sizing: border-box;
			height: 3.8rem;
			padding: .6rem .2rem .35rem;

			h1 {
				gap: .14rem;
				font-size: .4rem;
				color: #00C473;

				.tf {
					font-size: .64rem;
				}
			}

			p {
				margin-top: .3rem;
				font-size: .28rem;
				color: #686B73;
			}

			&-button {
				gap: .2rem;
				width: 100%;


				>>> .c-button {
					max-width: 4rem;
					height: .8rem !important;
					border-radius: .4rem !important;
					font-size: .32rem !important;

					&:nth-last-child(2) {
						border-color: #F3F5F9;
						background: #F3F5F9;
						color: #6A707F;
					}
				}
			}
		}
	}

	.output {
		&-tab {
			li {
				width: 50%;
				line-height: 1rem;
				font-size: .32rem;
				text-align: center;
				color: #444;
				background: #F2F2F2;

				&.z-crt {
					font-size: .36rem;
					font-weight: bold;
					color: #000;
					background: #fff;
				}
			}	
		}

		&-total {
			border: .02rem solid #CDE4EE;
			border-radius: .08rem;
			margin-top: .2rem;
			overflow: hidden;
			box-shadow: 0 .04rem .1rem 0 rgba(0,161,233,.15);

			dt {
				height: .8rem;
				padding: 0 .28rem;
				font-size: .3rem;
				color: #444;
				background: #F2FBFF;

				ins {
					width: .48rem;
					height: .48rem;
					border-radius: 50%;
					font-size: .2rem;
					color: #00A1E9;
					background: linear-gradient(0deg, #E8F8FF, #FFFFFF);
					box-shadow: 0 .04rem .1rem 0 rgba(0,161,233,.2);
				}
			}

			dd {
				border-top: .02rem solid #CDE4EE;

				ul {
					padding: .3rem .36rem;

					li {
						h5 {
							margin-bottom: .2rem;
							font-size: .3rem;
							font-weight: normal;
						}

						p {
							padding: 0 .04rem;
							line-height: .48rem;
							font-size: .26rem;
							color: #666;
						}
					}
				}
			}
		}

		&-time {
			margin-bottom: .2rem;
			font-size: .28rem;
			color: #666;
		}

		&-handle {
			margin-bottom: .2rem;
		}

		&-remove {
			position: absolute;
			right: 0;
			bottom: 0;
			box-sizing: border-box;
			min-width: .4rem;
			border-radius: .2rem 0 .2rem 0;
			padding: 0 .14rem;
			line-height: .4rem;
			font-size: .26rem;
			text-align: center;
			color: #fff;
			background: #f55;
		}
	}

	.add-member {
		box-sizing: border-box;
		width: .8rem;
		height: .8rem;
		border: 1px dashed #aaa;
		border-radius: 50%;
		margin-top: .1rem;
		margin-left: .12rem;
		font-size: .4rem;
		color: #aaa;
	}
</style>